import { render, staticRenderFns } from "./WorkFromHomeReview.vue?vue&type=template&id=2c3b8804&"
import script from "./WorkFromHomeReview.vue?vue&type=script&lang=js&"
export * from "./WorkFromHomeReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports